import {
  FETCH_LIST,
  LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  UPDATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE,
  SHOW_WORKER_BALANCE_DIALOG,
  SHOW_REJECT_JOIN_REQUEST_DIALOG,
  SET_IS_VETERAN,
  SHOW_DEDUCTION_DEPOSIT
} from './actionTypes'

export const fetchList = params => ({
  type: FETCH_LIST,
  payload: {
    params
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const setActiveState = (id, isActive) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive }
})

export const setIsVeteran = (id, isVeteran) => ({
  type: SET_IS_VETERAN,
  payload: { id, isVeteran }
})

export const showBalanceDialog = params => ({
  type: SHOW_WORKER_BALANCE_DIALOG,
  payload: { params }
})

export const showDeductionDeposit = params => ({
  type: SHOW_DEDUCTION_DEPOSIT,
  payload: { params }
})

export const showRejeactJoinRequestDialog = params => ({
  type: SHOW_REJECT_JOIN_REQUEST_DIALOG,
  payload: { params }
})
